export const OPEN_CONTENT_EDITOR = 'OPEN_CONTENT_EDITOR';
export const CLOSE_CONTENT_EDITOR = 'CLOSE_CONTENT_EDITOR';
export const EDITOR_UPDATE = 'EDITOR_UPDATE';

export const openContentEditor = value => ({ type: OPEN_CONTENT_EDITOR, value });
export const closeContentEditor = () => ({ type: CLOSE_CONTENT_EDITOR });
export const editorUpdate = () => ({ type: EDITOR_UPDATE });
